import { render } from "./SameAsBtn.vue?vue&type=template&id=7c3878e9&scoped=true"
import script from "./SameAsBtn.vue?vue&type=script&lang=js"
export * from "./SameAsBtn.vue?vue&type=script&lang=js"

import "./SameAsBtn.vue?vue&type=style&index=0&id=7c3878e9&lang=scss&scoped=true"

import exportComponent from "E:\\work\\flaggerforce\\flagger-force-orders-module\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3878e9"]])

export default __exports__